// 篮子
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("basket") || ""
}

const getters = {
  getBasket:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("basket",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("basket")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
